import React, { createContext, useContext, FC, PropsWithChildren } from 'react';
import { Template } from '../domain/entities/template';

export type PreviewTemplate = Template | null;

export interface PreviewTemplateContextValue {
  previewTemplate: PreviewTemplate;
  setPreviewTemplate: (t: PreviewTemplate) => void;
}

interface PreviewTemplateProviderProps {
  previewTemplate: PreviewTemplate;
  setPreviewTemplate: (t: PreviewTemplate) => void;
}

const PreviewTemplateContext = createContext<PreviewTemplateContextValue>({
  previewTemplate: null,
  setPreviewTemplate: (_t) => {},
});

export const PreviewTemplateContextProvider: FC<
  PropsWithChildren<PreviewTemplateProviderProps>
> = ({ previewTemplate, setPreviewTemplate, children }) => {
  return (
    <PreviewTemplateContext.Provider
      value={{ previewTemplate, setPreviewTemplate }}
    >
      {children}
    </PreviewTemplateContext.Provider>
  );
};

export const usePreviewTemplate = (): [
  PreviewTemplate,
  (t: PreviewTemplate) => void,
] => {
  const { previewTemplate, setPreviewTemplate } = useContext(
    PreviewTemplateContext,
  );
  return [previewTemplate, setPreviewTemplate];
};
